var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('input',{attrs:{"type":"hidden","required":_vm.required ? true : false,"formelementid":_vm.id},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }